<template>
  <div class="box mini-header">
    <div class="columns">
      <div class="column">
        <p class="menu-label" style="line-height: 1">
          ВСЕГО ОБРАЩЕНИЙ: <span style="font-weight: 700">{{ tickets.length }}</span><br>{{ $store.getters.USER.data['Наименование'] }}: <span style="font-weight: 700">{{ get_user_count() }}</span>
        </p>
      </div>
      <div class="column has-text-right tags">
        <div class="tag button is-dark" v-on:click="toTop()" v-if="toTopButton">
          НАВЕРХ&nbsp;<font-awesome-icon class="to-top-icon" icon="fa-solid fa-arrows-up-to-line" />
        </div>
        <div class="dropdown is-right is-hoverable" v-if="tickets.length !== 0">
          <div class="dropdown-trigger">
            <div class="tag button is-dark" :class="this.filters.state ? 'mygreenbtn' : ''" v-on:click="onOffFilters()">
              <font-awesome-icon icon="fa-solid fa-gear" :class="this.filters.state ? 'rotate-gear' : ''" />
            </div>
          </div>
          <div class="dropdown-menu" id="dropdown-menu4" role="menu" v-if="this.filters.state === true">
            <div class="dropdown-content">
              <div class="dropdown-item has-text-left">
                <div class="field" v-for="filter in filters.list" :key="filter" style="min-width: 200px">
                  <input v-model="filter.status" class="is-checkradio"  :id="filter.id" type="checkbox">
                  <label :for="filter.id">{{ filter.name }}</label>
                </div>
                <hr>
                <button style="width: 100% !important;" class="button is-dark" v-on:click="applyFilters()">СОХРАНИТЬ</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="field">
      <p class="control has-icons-right">
        <input class="input" type="text" v-model="search_field" placeholder="Введите поисковый запрос и нажмите Enter" v-on:change="search()">
        <span class="icon is-small is-right">
        <font-awesome-icon icon="fa-solid fa-magnifying-glass" />
      </span>
      </p>
    </div>
  </div>
  <div class="content">
    <table class="table is-striped is-narrow is-fullwidth sortable" v-on:mousemove="trigger()">
      <thead>
        <tr>
          <th v-for="field in filters.list" :key="field.id" :style="(filters.state && field.status) ? '' : 'display: none;'">
            {{ field.name }}
          </th>
          <th v-for="field in filters.list" :key="field.id" :style="(!filters.state) ? '' : 'display: none;'">
            {{ field.name }}
          </th>
        </tr>
      </thead>
      <tbody class="table-body" v-if="tickets.length > 0 && searched">
        <TicketPreview v-for="ticket in tickets" :key="ticket['Номер']" :ticket="ticket" :filters="filters"/>
      </tbody>
    </table>
    <TicketModal v-if="$store.getters.MODAL.status" v-model="$store.getters.MODAL.data" />
  </div>
  <div class="box" v-if="tickets.length === 0 && searched">
    <p>По данному запросу ничего не найдено!</p>
  </div>
</template>

<script>
import TicketPreview from "@/components/TicketPreview";
import TicketModal from "@/components/TicketModal";
import {getNormalDate} from "@/assets/getNormalDate";
import Cookies from "js-cookie";

export default {
  name: "ShowAndSearch",
  components: {
    TicketModal,
    TicketPreview
  },
  created () {
    window.addEventListener('scroll', this.scrollEvent);
  },
  async beforeMount() {
    await this.getTicketList()
  },
  data() {
    return {
      search_field: null,
      filters: {
        list: [],
        state: false
      },
      toTopButton: false,
      searched: true,
      tickets: this.$store.getters.TICKETS
    }
  },
  methods: {
    shorten: function (str) {
      if (str) return str.split(/\s+/).map((w,i) => i ? w.substring(0,1).toUpperCase() + '.' : w).join(' ');
      return str
    },
    get_user_count: function () {
      let my_tickets = this.tickets.filter(el => el['Заявитель'] === this.$store.getters.USER.data['Наименование'])
      if (my_tickets.length) {
        return my_tickets.length
      }
      return 0
    },
    onOffFilters: function () {
      this.filters.state = !this.filters.state
      this.applyFilters()
    },
    initFilters: function () {
      let tmp_list = []
      if (this.tickets && this.tickets.length > 0) {
        for (let key of Object.keys(this.tickets[0])) {
          if (!this.$config.HIDDEN_COLUMNS.includes(key)) {
            if (this.$config.NAMES[key]) {
              tmp_list.push({
                name: this.$config.NAMES[key],
                id: key,
                status: true
              })
            } else {
              tmp_list.push({
                name: key,
                id: key,
                status: true
              })
            }
          }
        }
      }

      if (Cookies.get(`f-${this.$store.getters.USER.guid}`)) {
        if (this.compareFilters(JSON.parse(Cookies.get(`f-${this.$store.getters.USER.guid}`)).list, tmp_list)) {
          this.filters = JSON.parse(Cookies.get(`f-${this.$store.getters.USER.guid}`))
        } else {
          this.filters = {
            state: false,
            list: tmp_list
          }
        }
      } else {
        this.filters = {
          state: false,
          list: tmp_list
        }
      }
      this.applyFilters()
    },
    compareFilters(firstList, secondList) {
      let keysOfFirst = []
      let keysOfSecond = []
      for (let element of firstList) {
        keysOfFirst.push(element.name)
      }
      for (let element of secondList) {
        keysOfSecond.push(element.name)
      }
      if (JSON.stringify(keysOfFirst) === JSON.stringify(keysOfSecond)) {
        console.log('Список фильтров неизменен')
        return true
      } else {
        console.log('Список фильтров изменился, веду пересчёт...')
        return false
      }
    },
    toTop: function () {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    },
    scrollEvent: function () {
      const scrollY = window.scrollY || document.documentElement.scrollTop
      scrollY > 200 ? this.toTopButton = true : this.toTopButton = false
    },
    applyFilters: function () {
      console.log('Сохранил в Печеньки!')
      Cookies.set(`f-${this.$store.getters.USER.guid}`, JSON.stringify(this.filters), { expires: 365 })
    },
    getTicketList: async function () {
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.DB}/${this.$config.API_VERSION}/GetTickets`
      let properies = {
        method: 'POST',
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.$store.getters.TOKEN
        }
      }
      await fetch(url, properies)
          .then(response => response.text())
          .then(async result => {
            await this.updateTicketList(JSON.parse(result))
          })
    },
    updateTicketList: async function (tickets) {
      for (let ticket of tickets) {
        Object.keys(ticket).forEach(
            (key) => (ticket[key] === null) ? ticket[key] = 'не указано' : ticket[key]
        )
      }

      for (let ticket of tickets) {
        Object.keys(ticket).forEach(
            (key) => {
              if (key === 'ДатаОбращения' && ticket[key]) {
                ticket[key] = getNormalDate(ticket[key])
              }
              if (key === 'ДатаРеакции' && ticket[key]) {
                ticket[key] = getNormalDate(ticket[key])
              }
              if (key === 'ДатаВыполнения' && ticket[key]) {
                ticket[key] = getNormalDate(ticket[key])
              }
              if (key === 'РаботоспособностьВосстановлена' && ticket[key]) {
                ticket[key] = getNormalDate(ticket[key])
              }
            }
        )
      }
      this.$store.dispatch('TICKETS', tickets)
      this.tickets = this.$store.getters.TICKETS

      await this.initFilters()
    },
    trigger: function () {
      document.querySelectorAll(".sortable th").forEach(headerCell => {
        headerCell.addEventListener("click", () => {
          const tableElement = headerCell.parentElement.parentElement.parentElement;
          const headerIndex = Array.prototype.indexOf.call(headerCell.parentElement.children, headerCell);
          const currentIsAscending = headerCell.classList.contains("th-sort-asc");
          this.sortTableByColumn(tableElement, headerIndex, !currentIsAscending);
        });
      });
    },
    sortTableByColumn: function (table, column, asc = true) {
      const dirModifier = asc ? 1 : -1;
      const tBody = table.tBodies[0];
      const rows = Array.from(tBody.querySelectorAll("tr"));
      const sortedRows = rows.sort((a, b) => {
        const aColText = a.querySelector(`td:nth-child(${ column + 1 })`).textContent.trim();
        const bColText = b.querySelector(`td:nth-child(${ column + 1 })`).textContent.trim();
        return aColText > bColText ? (1 * dirModifier) : (-1 * dirModifier);
      });
      while (tBody.firstChild) {
        tBody.removeChild(tBody.firstChild);
      }
      tBody.append(...sortedRows);
      table.querySelectorAll("th").forEach(th => th.classList.remove("th-sort-asc", "th-sort-desc"));
      table.querySelector(`th:nth-child(${ column + 1})`).classList.toggle("th-sort-asc", asc);
      table.querySelector(`th:nth-child(${ column + 1})`).classList.toggle("th-sort-desc", !asc);
    },

    search: function () {
      this.tickets = []
      this.searched = false
      if (this.$store.getters.TICKETS.length > 0) {
        for(let i = 0; i < this.$store.getters.TICKETS.length; i++) {
          for(let key in this.$store.getters.TICKETS[i]) {
            if(!this.$config.HIDDEN_COLUMNS.includes(key)) {
              if (this.$store.getters.TICKETS[i][key].toLowerCase().indexOf(this.search_field.toLowerCase())!=-1) {
                if (!this.tickets.includes(this.$store.getters.TICKETS[i])) {
                  this.tickets.push(this.$store.getters.TICKETS[i])
                }
              }
            }
          }
        }
      }
      this.searched = true
    }
  }
}
</script>

<style lang="scss" scoped>
.mygreenbtn {
  background-color: rgb(45, 140, 0) !important;
}
.rotate-gear {
  animation: rotation 8s linear 0s infinite normal forwards;
  transition: 1s;
}
.my-top-btn {
  position: fixed;
  bottom: 5px;
  right: 5px;
  width: calc(100% - 10px);
  p {
    color: white !important;
  }
}

.to-top-icon {
  animation: arrow-animate 2s linear infinite;
}

@keyframes arrow-animate {
  $movment-px: 2px;
  from {
    opacity: 0;
    transform: translateY($movment-px);
  }
  5% {
    opacity: 1;
    transform: translateY($movment-px);
  }
  95% {
    opacity: 1;
    transform: translateY($movment-px*-1);
  }
  to {
    opacity: 0;
    transform: translateY($movment-px*-1);
  }
}

@keyframes rotation {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}

.mini-header {
  position: sticky !important;
  border-radius: 0 !important;
  top: 20px !important;
  z-index: 20 !important;
  backdrop-filter: blur(10px) grayscale(1);
  background-color: transparent;
}

.sortable th {
  cursor: pointer;
  transition: 0.3s;
}
.sortable th:hover {
  background: rgba(0, 0, 0, 0.1);
  border-radius: 20px 20px 0 0;
}

.sortable .th-sort-asc::after {
  content: "\25b4";
}

.sortable .th-sort-desc::after {
  content: "\25be";
}

.sortable .th-sort-asc::after,
.sortable .th-sort-desc::after {
  margin-left: 5px;
}

.sortable .th-sort-asc,
.sortable .th-sort-desc {
  border-radius: 10px 10px 0 0;
  background: rgba(0, 0, 0, 0.05);
}
</style>
